import { useCallback, useState } from "react";
import Modal from "../../../common/components/Modal";
import { Button } from "~/common/components/Button/Button";
import { Stacker } from "~/common/components/Stacker/Stacker";
import {
  makeOnFilterChange,
  type NotificationFilterEntry,
  NotificationsFilters,
} from "~/Notifications/NotificationsPage/components/NotificationsFilters";
import classNames from "classnames";
import classes from "./NotificationsFiltersModal.module.less";
import { useTranslation } from "react-i18next";

interface NotificationsFiltersProps {
  currentFilters: NotificationFilterEntry[];
  onClose: () => void;
  onApply: (newFilters: NotificationFilterEntry[]) => void;
}

export const NotificationsFiltersModal = ({ currentFilters, onClose, onApply }: NotificationsFiltersProps) => {
  const { t } = useTranslation();

  const [filters, setFilters] = useState(currentFilters);

  const clearAllCb = () => {
    onClose();
  };
  const applyCb = () => {
    onClose();
    onApply(filters);
  };

  const onFilterChange = useCallback(makeOnFilterChange(setFilters), []);

  return (
    <Modal
      onClose={onClose}
      title={t("notificationsPage.filters.title")}
      footerChildren={
        <Stacker gap={8} direction={"row"}>
          <Button variant={"text"} onClick={clearAllCb} data-test-id={"confirmation-modal-cancel"}>
            {t("cancel")}
          </Button>
          <Button onClick={applyCb} data-test-id={"confirmation-modal-ok"}>
            {t("searchPage.showResults")}
          </Button>
        </Stacker>
      }
    >
      <NotificationsFilters filters={filters} onFilterChange={onFilterChange} />
    </Modal>
  );
};
